import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// import {setCurrentTime} from '../../redux/Slices/startFullTestSlice'
import { setCurrentTime } from '../../redux/Slices/StartTestSlice/startFulTest';
import { useAppSelector } from '../../redux/store/hooks';

const Timer = () => {
  const timer = useAppSelector(state => state.root.startFulltest.currentTime);
  const dispatch = useDispatch();
  // const currentTime =  useAppSelector(state => state.root.newTemplete[0]?.rounds[0]?.sections[0]?.sectionalTiming);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (timer <= 0) {
        clearInterval(intervalId);
        dispatch(setCurrentTime(0));
      } else {
        dispatch(setCurrentTime(timer - 1));
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timer]);
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;
  const displayTime = `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;

  return <div>{displayTime}</div>;
};

export default Timer;
